import styled from 'styled-components';

export const HomeSpecsStyles = styled.div`
  display: flex;

  > div {
    margin-right: 24px;

    &:last-child {
      margin-right: 0;
    }

    .icon {
      display: block;
      margin-bottom: 4px;
      margin-right: 6px;
      position: relative;
      top: 2px;
    }
  }
`;
